// import React, { useEffect, useState } from 'react';
// import './people.css';
// import { Base_Url } from '../config';

// const AtAGlimpse = () => {
//   const [allFaculty, setAllFaculty] = useState([]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await fetch(`${Base_Url}/profiles`);
//       const data = await response.json();
      

//       // Filter for retired staff (isretired === true) and specific designations
//       const retiredFaculty = data.filter(person => 
//         person.isretired === 1 && 
//         (
//           person.designation === 'System Architect' ||
//           person.designation === 'System Manager' ||
//           person.designation === 'Sr. System Manager (SG)'
//         )
//       );

//       console.log(retiredFaculty)
//       // Sort by designation for better organization
//       const sortedFaculty = retiredFaculty.sort((a, b) => 
//         a.designation.localeCompare(b.designation)
//       );

//       setAllFaculty(sortedFaculty);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     }
//   };

//   console.log(allFaculty)

//   return (
//     <div className="at-a-glimpse-container">
//       <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0">
//         Ex <span className="highlight-title">Faculty Members</span>
//       </h2>
//       <hr />
      
//       <div className="at-a-glimpse-table-container">
//         <table className="at-a-glimpse-table">
//           <thead>
//             <tr className="at-a-glimpse-table-header">
//               <th style={{background:"#c21717", color:"#fff"}}>Name</th>
//               {/* <th style={{background:"#c21717", color:"#fff"}}>Designation</th> */}
//             </tr>
//           </thead>
//           <tbody>
//             {allFaculty.map((person, index) => (
//               <tr key={index}>
//                 <td className="fw-semibold">
//                   {person.name}
//                 </td>
//                 {/* <td className="fw-bold" style={{color:"#c21717"}}>
//                   {person.designation}
//                 </td> */}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default AtAGlimpse;


import React, { useEffect, useState } from 'react';
import './people.css';
import { Base_Url } from '../config';

const AtAGlimpse = () => {
  const [allFaculty, setAllFaculty] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(`${Base_Url}/profiles`);
      const data = await response.json();
      
      // Filter for retired staff and specific designations
      const retiredFaculty = data.filter(person => 
        person.isretired === 1 &&
        (
          person.designation === 'System Architect' ||
          person.designation === 'System Manager' ||
          person.designation === 'Sr. System Manager (SG)'
        )
      );

      // Sort by designation
      const sortedFaculty = retiredFaculty.sort((a, b) => 
        a.designation.localeCompare(b.designation)
      );

      setAllFaculty(sortedFaculty);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Function to chunk array into groups of 4
  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  return (
    <div className="at-a-glimpse-container">
     <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0 text-center">
  Former Academic <span className="highlight-title"> Members</span>
</h2>

      <hr />
      
      <div className="at-a-glimpse-table-container">
        <table className="at-a-glimpse-table" style={{cursor:"default"}}>
          <thead>
            <tr  className="at-a-glimpse-table-header">
              <th style={{background:"#c21717", color:"#fff", textAlign:"center" ,cursor:"default"}}>Academic Members</th>
            </tr>
          </thead>
          <tbody>
            {chunkArray(allFaculty, 5).map((row, rowIndex) => (
              <tr style={{cursor:"default",textAlign:"center"}} key={rowIndex}>
                <td style={{cursor:"default",textAlign:"center"}}>
                  {row.map((person, index) => (
                    <React.Fragment key={index} >
                      <span className="fw-semibold " style={{cursor:"default"}}>{person.name}</span>
                      {index < row.length - 1 && <span className="px-2">|</span>}
                    </React.Fragment>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AtAGlimpse;